import React from 'react';

const Logo = () => {
    return (
        <img src={require('../../assets/logo.png')} width={212.2} height={49.45} draggable={false}/>
    );
};

export default Logo;